import { useEffect, useState } from "react";
import {
  azureNodesData,
  line3Conditions,
} from "../const/dataV2";
import { initialNodesData } from "../const/data";
import { getLine3Nodes } from "../utils/getLine3Nodes";

export const useDiagramDataV2 = () => {
  const [diagramData, setDiagramData] = useState(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const logo = searchParams.get("url_logo") || searchParams.get("logo");
    const nombre = searchParams.get("solutionName") || searchParams.get("nombre") || "Solution Name";
    const color1 = `#${searchParams.get("color1") || "0078D4"}`;
    const userColor = searchParams.get("color") ? `#${searchParams.get("color")}` : "#00BCF2";
    const hasOnboarding = searchParams.get("hasOnboarding");

    // Get features from URL params (line === 0 items)
    const featureNodes = getLine3Nodes(searchParams, initialNodesData, line3Conditions);

    // Transform to items format
    const otherFeaturesItems = featureNodes.map(node => ({
      image: node.data.image,
      label: node.data.label,
      color: color1,
    }));

    // Get onboarding steps if enabled
    let onboardingSteps = null;
    if (hasOnboarding === "T") {
      const steps = [];

      for (let i = 1; i <= 10; i++) {
        const hasStep = searchParams.get(`hasonboardingstep${i}`);
        const codeStep = searchParams.get(`codeonboardingstep${i}`);

        if (hasStep === "t" && codeStep) {
          const node = initialNodesData.find(
            (n) => n.id.toUpperCase() === codeStep.toUpperCase() && n.line === 1
          );

          if (node) {
            steps.push({
              code: codeStep,
              label: node.data.label,
              image: node.data.image,
            });
          }
        }
      }

      if (steps.length > 0) {
        onboardingSteps = steps;
      }
    }

    // Get 3rd party logos from URL params
    const thirdPartyLogos = [];
    const addedLogos = new Set(); // Track added logos to avoid duplicates
    const logoParams = Array.from(searchParams.entries()).filter(
      ([key]) => key.startsWith("logo") && key !== "logo"
    );

    logoParams.forEach(([key, value]) => {
      if (value === "t") {
        // Extract logo name (e.g., "logomambu" -> "Mambu")
        const logoName = key.substring(4).toLowerCase(); // Remove "logo" prefix and lowercase

        // Skip if already added
        if (addedLogos.has(logoName)) {
          return;
        }
        addedLogos.add(logoName);

        // Capitalize first letter: "mambu" -> "Mambu"
        const capitalizedName = logoName.charAt(0).toUpperCase() + logoName.slice(1);

        // Try different extensions - will default to .png in the path
        // The browser will handle 404s gracefully with onError handler
        const logoPath = `/logo/logo${capitalizedName}.png`;

        thirdPartyLogos.push({
          logoPath,
          logoPathJpg: `/logo/logo${capitalizedName}.jpg`,
          logoPathWebp: `/logo/logo${capitalizedName}.webp`,
          name: capitalizedName,
        });
      }
    });

    setDiagramData({
      logo,
      nombre,
      color1,
      userColor,
      leftSideItem: { label: "Final Users", color: userColor },
      onboardingSteps,
      otherFeaturesItems,
      identityItems: azureNodesData.identityItems,
      systemHealthItems: thirdPartyLogos,
      networkingItems: azureNodesData.networkingItems,
    });
  }, []);

  return diagramData;
};
